var _defs, _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFledglingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.83 13.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f0efe1;\n      }\n\n      .cls-2 {\n        stroke: #f0efe1;\n        stroke-linejoin: round;\n        stroke-width: .28px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #414042;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 6.01,
    width: 4.22,
    height: 1.81
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m3.6,6.91C1.99,5.35,1.23,2.28,1.17.14c2.2,2.87,5.06,5.37,8.52,6.77-3.46,1.34-6.19,3.99-8.52,6.77.19-2.29.76-5.06,2.43-6.77"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 6.29,
    width: 4.22,
    height: 1.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFledglingArrow);
export default __webpack_public_path__ + "static/media/FledglingArrow.059ea214ffa02bb537dfa52b9b746f5c.svg";
export { ForwardRef as ReactComponent };